module.exports = __webpack_public_path__ + "static/img/head_1.8746b613.png";